document.addEventListener('DOMContentLoaded', function () {
  var productMenus = document.querySelectorAll('.rm-products');

  document.addEventListener('click', function (event) {
    productMenus.forEach(function (menu) {
      if (menu.open && !menu.contains(event.target)) menu.removeAttribute('open');
    });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    productMenus.forEach(function (menu) { menu.removeAttribute('open'); });
  });
});
